/** True when the click target is table UI chrome (not row body navigation). */
export function isTableChromeTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null
  if (!el?.closest) return false
  return Boolean(
    el.closest(
      'button,a,.ant-btn,.ant-checkbox,.ant-table-selection-column,.ant-pagination,.ant-select,.ant-picker,.ant-picker-dropdown,.ant-dropdown,.ant-table-filter-trigger,.ant-table-filter-dropdown,.ant-dropdown-menu,.ant-table-column-sorter,.ant-tooltip,.leap-table-action-btn'
    )
  )
}
